import React from 'react'
import {Image, Link, Text} from '@sitecore-jss/sitecore-jss-react';
import PrintProps from "./PrintProps";
import { ComponentProps } from '../../types/types';

const TestNoParams = (props: ComponentProps) => {
    const FieldsPart = props.fields? (() => (
        <>
            <Text field={props.fields?.heading} tag='p'/>
            <Link field={props.fields?.routableSitecoreLink}/>
            <Link field={props.fields?.link}/>
            <Image field={props.fields?.image}/>
        </>
    )) : (()=><p>Missing "fields" prop</p>);

    return <div style={{backgroundColor: "white", border: "1px solid black", overflow: "hidden"}}>
        <p>TestNoParams Component</p>
        <FieldsPart/>
        <PrintProps {...props}/>
    </div>;
};

export default TestNoParams;
